import * as Actions from 'app/store/actions/ctm/dataUpdate.actions';
import { RESET_CTM } from 'app/store/actions/ctm/landing.actions';

const initialState = {
	infos:[],
};

const dataUpdateReducer = (state = initialState, action) => {
	switch (action.type) {
		case RESET_CTM: {
			return { ...initialState };
		}
		case Actions.LIST_DATA_UPDATE_INFO: {
			return {
				...state,
				infos: action.data,
			};
		}
		default: {
			return state;
		}
	}
};

export default dataUpdateReducer;
